// 상세 이미지 한 장으로 구성된 행사 매장
// 매장 상세에서 헤더·대표 사진·매장명·매장 정보 영역을 숨기고, 예약하기 버튼을 화면 고정 대신 페이지 최하단에 배치
const EVENT_DETAIL_MALLS = [
	'6acf08db282b72147ad92932', // 더한옥헤리티지 리추얼 데이 (2026.10.29)
]

export const isEventDetailMall = mallId => EVENT_DETAIL_MALLS.includes(mallId)

// 행사 매장의 홈(예약 완료 화면의 홈·닫기 이동 위치)
export const getEventHomePath = mallId => (isEventDetailMall(mallId)
	? `/booking/mall-detail/${mallId}`
	: null)
